import React from 'react';
import { motion } from 'framer-motion';
import fromOne from '../../../assets/images/home_screen/form_one.webp';
import fromTwo from '../../../assets/images/home_screen/form_two.webp';
import fromThree from '../../../assets/images/home_screen/form_three.webp';
import leftStars from '../../../assets/images/home_screen/our_team_left_stars.svg';
import rightStars from '../../../assets/images/home_screen/our_team_right_stars.svg';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';

const ExpectFromAppointment = () => {
  const forms = [
    {
      src: fromThree,
      rotate: '-rotate-[15deg] top-0 right-[60px] md:right-0',
    },
    {
      src: fromOne,
      rotate: '-rotate-[5deg] -top-5 -right-[0px] md:-right-[50px]',
    },
    {
      src: fromTwo,
      rotate: 'rotate-[6deg] -top-4 -right-[70px] md:-right-[110px]',
    },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.75,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
  };

  return (
    <div
      id="your_appointment"
      className="bg-[#4D535C] relative min-w-full h-full"
    >
      <div className=" flex flex-col md:flex-row items-center justify-center max-w-[1200px] mx-auto px-4 md:px-10 py-14 md:py-28 gap-32 md:gap-20">
        <div className="flex-1">
          <div className="relative w-[200px] h-[270px] md:w-[300px] md:h-[400px] flex justify-center items-end -mt-10 md:mt-4">
            <motion.div
              className="relative w-[200px] h-[200px] md:w-[300px] md:h-[400px] flex justify-center items-end"
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: false, amount: 0.2 }} // Runs animation every time it comes into view
            >
              {forms.map((form, index) => (
                <motion.div
                  key={index}
                  className={`absolute ${form.rotate} w-[200px] h-[200px] md:w-[300px] md:h-[400px]`}
                  variants={itemVariants}
                >
                  <img src={form.src} alt={`Form ${index + 1}`} />
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
        <div className="flex-1">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            What to Expect at <br />
            Your Appointment
          </h2>
          <p className="text-lg text-white mt-6">
            When you and your child come to the initial evaluation, you will be
            greeted by one of our friendly and personable front office care
            coordinators in a relaxing and engaging waiting room complete with
            amenities and comfortable furniture to decompress. Depending on the
            age of your child and what tests are required, your therapist may
            ask you to come into the evaluation area with them, observe through
            a one way window or wait in our waiting room during the evaluation
            process.
          </p>
          <p className="text-lg text-white mt-5">
            If this is your first appointment, please download and complete the
            New Patient Forms on the Forms page.
          </p>
          <div className="flex items-center gap-3 mt-5">
            <GradientOutlineButton
              text={'What To Expect'}
              navigateTo={'/appointment'}
              isDark={true}
            />
            <GradientOutlineButton
              text={'Go to Forms'}
              isDark={true}
              navigateTo={'/resources/forms'}
            />
          </div>
        </div>
      </div>
      <img
        src={leftStars}
        alt="our_team_left_stars"
        className="absolute top-0 left-0 w-[25%]"
      />
      <img
        src={rightStars}
        alt="our_team_left_stars"
        className="absolute top-0 right-0 w-[30%]"
      />
    </div>
  );
};

export default ExpectFromAppointment;
